import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Calendar, User } from 'lucide-react';
import '../styles/blog-detail.css';

const BlogDetail = ({ blog }) => {
  
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  if (!blog) {
    return (
      <div className="blogdetail-wrapper">
        <div className="blogdetail-inner">
          <p style={{ color: '#231F20', textAlign: 'center', marginTop: '4rem' }}>Blog post not found</p>
        </div>
      </div>
    );
  }

  return (
    <div className="blogdetail-wrapper">


      <div className="blogdetail-inner">
        <article className="blogdetail-article">
          <header className="blogdetail-header">
            <span className="blogdetail-category">{blog.category}</span>
            <h1 className="blogdetail-title">{blog.title}</h1>
            
            <div className="blogdetail-meta">
              <div className="blogdetail-meta-item">
                <User size={18} />
                <span>{blog.author}</span>
              </div>
              <div className="blogdetail-meta-divider">•</div>
              <div className="blogdetail-meta-item">
                <Calendar size={18} />
                <span>{blog.date}</span>
              </div>
            </div>
          </header>

          <div className="blogdetail-image">
            <img src={blog.image} alt={blog.title} loading="lazy" />
          </div>

          <div className="blogdetail-body">
            <p className="blogdetail-lead">{blog.excerpt}</p>

            <div className="blogdetail-sections">
              <section className="blogdetail-section">
                <h2>Introduction</h2>
                <p>
                  In today's rapidly evolving business landscape, {blog.title.toLowerCase()} has become 
                  a critical factor for companies seeking to maintain competitive advantage. This comprehensive 
                  guide explores the latest trends, best practices, and innovative strategies that are shaping 
                  the future of global commerce.
                </p>
              </section>

              <section className="blogdetail-section">
                <h2>Key Insights</h2>
                <p>
                  Industry leaders are increasingly recognizing the importance of sustainable and ethical business 
                  practices. Our research shows that companies implementing these principles not only contribute to 
                  environmental and social well-being but also achieve stronger financial performance and customer loyalty.
                </p>
              </section>

              <section className="blogdetail-section">
                <h2>Implementation Strategies</h2>
                <p>
                  Successful implementation requires a multi-faceted approach that combines technological innovation, 
                  strategic partnerships, and a commitment to continuous improvement. Companies must invest in the right 
                  infrastructure, train their teams, and establish clear metrics for measuring progress.
                </p>
              </section>

              <section className="blogdetail-section">
                <h2>Looking Ahead</h2>
                <p>
                  As we move forward, the integration of advanced technologies and sustainable practices will continue 
                  to transform the industry. Organizations that embrace these changes and adapt proactively will be 
                  best positioned to thrive in the evolving global marketplace.
                </p>
              </section>
            </div>

            <div className="blogdetail-conclusion">
              <h3>Conclusion</h3>
              <p>
                {blog.excerpt} By staying informed about industry trends and implementing best practices, 
                businesses can navigate challenges effectively and capitalize on emerging opportunities.
              </p>
            </div>
          </div>
        </article>
      </div>
    </div>
  );
};

export default BlogDetail;
